import DynamicMenu from "./dynamic-menu";
import EmailTemplates from "./dynamic-menu";

const modules = [EmailTemplates, DynamicMenu];

export default modules;
